import React, { useCallback, useMemo } from "react";
import { getShouldShow } from "~/components/acquisition-popup-container/display/helpers";
import { useSdkContext } from "~/components/contexts";
import { getWhyRegisterActionKey } from "./actions";
import { SanitizedUrlKeys } from "./consts";
import { WhyRegisterPopup } from ".";
export const useWhyRegisterPopupGetter = options => {
  const {
    acquisition: {
      popupState
    },
    currentRoute,
    handleRemoveRouteQuery,
    handleTrackGA,
    hasWhyRegisterPPTOHomepagePositionIntersected,
    userCountry,
    userTypeIds
  } = useSdkContext();
  const getNextFromAction = useCallback(() => {
    const actionKey = getWhyRegisterActionKey(new URL(currentRoute, window.location.origin).search);
    if (!actionKey) return;
    handleTrackGA({
      action: `Acquisition/${actionKey}/Why_Register/success`,
      category: "Acquisition",
      label: ""
    });
    void handleRemoveRouteQuery(SanitizedUrlKeys);
  }, [currentRoute, handleRemoveRouteQuery, handleTrackGA]);
  const getNextFromConfig = useCallback(handleClose => {
    var _nextConfig$timeout;
    const nextConfig = Object.values(popupState.whyRegister).find(whyRegister => !whyRegister.positioningTrigger && getShouldShow({
      config: whyRegister,
      userInfo: {
        isLoggedIn: options.isLoggedIn,
        userCountry: userCountry !== null && userCountry !== void 0 ? userCountry : "",
        userTypeIds
      }
    }));
    if (!nextConfig) return;
    const props = {
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose,
      whyRegister: nextConfig
    };
    return {
      delay: Number.parseInt((_nextConfig$timeout = nextConfig.timeout) !== null && _nextConfig$timeout !== void 0 ? _nextConfig$timeout : "0", 10),
      element: /*#__PURE__*/React.createElement(WhyRegisterPopup, props),
      localStorageKey: nextConfig.localStorageKey,
      updateLocalStorageOnShow: true
    };
  }, [options.isLoggedIn, options.modalContainerReference, popupState.whyRegister, userCountry, userTypeIds]);
  const getNextFromScrollPosition = useCallback(handleClose => {
    var _nextConfig$timeout2;
    const nextConfig = Object.values(popupState.whyRegister).find(whyRegister => whyRegister.positioningTrigger && getShouldShow({
      config: whyRegister,
      userInfo: {
        isLoggedIn: options.isLoggedIn,
        userCountry: userCountry !== null && userCountry !== void 0 ? userCountry : "",
        userTypeIds
      }
    }));
    if (!nextConfig || !hasWhyRegisterPPTOHomepagePositionIntersected) return;
    const props = {
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose,
      whyRegister: nextConfig
    };
    return {
      delay: Number.parseInt((_nextConfig$timeout2 = nextConfig.timeout) !== null && _nextConfig$timeout2 !== void 0 ? _nextConfig$timeout2 : "0", 10),
      element: /*#__PURE__*/React.createElement(WhyRegisterPopup, props),
      localStorageKey: nextConfig.localStorageKey,
      updateLocalStorageOnShow: true
    };
  }, [hasWhyRegisterPPTOHomepagePositionIntersected, options.isLoggedIn, options.modalContainerReference, popupState.whyRegister, userCountry, userTypeIds]);
  const getters = useMemo(() => ({
    getNextFromAction,
    getNextFromConfig,
    getNextFromScrollPosition
  }), [getNextFromAction, getNextFromConfig, getNextFromScrollPosition]);
  return getters;
};